// extracted by mini-css-extract-plugin
module.exports = {"headerDatetime":"CurrentTime_headerDatetime__1_Q4v"};